import { RegistrationStatus } from '@exam-center/graphql';

import { BaseSearchSelection } from '../base-search-selection';

const REGISTRATION_STATUS_OPTIONS = [
  { label: 'เปิดรับสมัคร', value: RegistrationStatus.OpenForRegistration },
  { label: 'ปิดรับสมัครชั่วคราว', value: RegistrationStatus.TemporarilyClosed },
  { label: 'ปิดรับสมัคร', value: RegistrationStatus.RegistrationClosed },
  { label: 'รอบสอบเต็ม', value: RegistrationStatus.SessionFull },
  { label: 'ยกเลิกรอบสอบ', value: RegistrationStatus.Canceled },
];

interface RegistrationStatusSearchSelectionProps {
  value: { label: string; value: RegistrationStatus }[];
}

export default function RegistrationStatusSearchSelection(
  props: Readonly<RegistrationStatusSearchSelectionProps>,
) {
  const { value } = props;

  return (
    <BaseSearchSelection
      name='registrationStatus'
      options={REGISTRATION_STATUS_OPTIONS}
      label='สถานะการรับสมัคร'
      value={value}
    />
  );
}
